import "./style.scss";
import pic from "Assets/Images/MediaDaapApp/blog2.png";
import { FileBarGraph } from "react-bootstrap-icons";
import { Link, useLocation } from "react-router-dom";
import API from "Constants/Apis";
import { Fragment } from "react";

const Index = ({ related }) => {
  const { pathname } = useLocation();

  return (
    <Fragment>
      {Array.isArray(related) && related.length > 0 ? (
        <div className=" each-box-site container-media-daapapp py-5  d-flex flex-column ">
          {pathname.includes("blog") ? null : (
            <div className="up-title-box py-4 text-center">
              <h5 className="">رسانه داپ‌اَپ</h5>
              <p className="vazir-l">
                مطالب و مقالات مفید در حوزه مالی و کسب درآمد
              </p>
            </div>
          )}

          <div className="each-main-box mb-4 each-main-media-daapapp d-flex justify-content-between ">
            {related?.length > 0
              ? related?.map((eachRelated) => {
                  return (
                    <div className="each-useful-content" key={eachRelated.id}>
                      <img
                        src={eachRelated.medias.map((url) => {
                          return `${API.BASE_URL_IMAGE}${url.media_path}`;
                        })}
                        alt=""
                        loading="lazy"
                      />
                      <h6 className="text-center ">{eachRelated.subject} </h6>
                      <p className=" text-justify ">
                        {`${eachRelated.caption.slice(0, 150)} ....`}
                      </p>
                      <Link
                        to={`/blog/${eachRelated.id}`}
                        className="more-media-daapapp px-3 py-1  btn-white text-success bg-white rounded-pill"
                      >
                        ادامه....
                      </Link>
                    </div>
                  );
                })
              : null}
          </div>

          {pathname.includes("blog") ? null : (
            <div className="buttons-box py-4">
              <button className="border-0 rounded-pill bg-primery text-white bg-primary all-butten-site ">
                <FileBarGraph className="ms-2" color="white" />
                لیست کسب و کارها
              </button>
            </div>
          )}
        </div>
      ) : null}
    </Fragment>
  );
};

export default Index;
